import axios from 'axios';
import { Domain, Juridiction, Ville, Enterprise } from '../entity/entity.types';
import { getAccessKey } from './lawyerUtils';
import { Commentary } from '../commentary/commentary.types';
import { NavLawyerInfos, LawyerCardInfosType } from './lawyer.types';

export async function fetchLawyerDecisions(
  lawyerId: string,
): Promise<{
  domains: Domain[];
  decisionCount: number;
  juridictions: Juridiction[];
  villes: Ville[];
}> {
  const readKey = getAccessKey();
  return (
    await axios.get('/getLawyerDecisions', {
      params: {
        lawyerId,
        readKey,
      },
    })
  ).data;
}

export async function fetchLawyerEnterprises(
  lawyerId: string,
  full: boolean = false,
): Promise<{
  enterprises: Enterprise[];
  hasMore: boolean;
  pluralityState: number;
}> {
  const readKey = getAccessKey();
  return (
    await axios.get('/getLawyerEnterprises', {
      params: {
        lawyerId,
        readKey,
        full,
      },
    })
  ).data;
}

export async function fetchLawyerCommentaries(
  lawyerId: string,
  full: boolean,
  userGeneratedOnly: boolean,
): Promise<{ commentaries: Array<Commentary>; totalNumber: number }> {
  return (
    await axios.get('/professional_ajax/getCommentaries', {
      params: {
        lawyerId,
        full,
        userGeneratedOnly,
      },
    })
  ).data;
}

export async function fetchLawyerInfos(
  lawyerId: string,
): Promise<LawyerCardInfosType> {
  return (
    await axios.get('/getLawyerPopover', {
      params: {
        lawyerId,
      },
    })
  ).data;
}

export async function fetchProfessionalInfos(): Promise<NavLawyerInfos> {
  return (await axios.get('/getProfessionalInfos')).data;
}

export async function setWantToBeContacted(lawyerId: string): Promise<void> {
  return (await axios.post('/wantToBeContacted', { lawyerId })).data;
}
